/** @enum enumDigitalMediaDisplayEnvironment represents the display environment options for a digital media object.
 */
export enum enumDigitalMediaDisplayEnvironment {
    AppHeaderButton = 'AppHeaderButton',
    CardView = 'CardView',
    ListView = 'ListView',
    FormView = 'FormView',
  }
  